import { mapKeys } from 'lodash'
import refData from '@wix/document-services-json-schemas/dist/refData.json'
import { CatharsisArgs } from '@wix/thunderbolt-catharsis'

type Schemas = CatharsisArgs['extensions']['schemas']

export const defaultSchemas: Schemas = mapKeys(refData, (__, key) => key.replace('.json', ''))
